export function pluralRu(value: number, one: string, few: string, many: string) {
  const absolute = Math.abs(value) % 100
  const last = absolute % 10
  if (absolute > 10 && absolute < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}
